import React from "react";
import { FileText } from "lucide-react";

const OPTS = [
  { k: "all", label: "Tümü", on: "bg-slate-900 text-white" },
  { k: "open", label: "Açık", on: "bg-emerald-600 text-white" },
  { k: "closed", label: "Kapalı", on: "bg-slate-600 text-white" },
];

export function EkstreFilter({ value, onChange, counts }) {
  return (
    <div className="inline-flex items-center rounded-lg border border-slate-200 overflow-hidden" data-testid="ekstre-filter" title="Prim ekstresi erişimine göre filtrele">
      <span className="px-2 py-2 text-[11px] font-semibold text-slate-500 bg-slate-50 inline-flex items-center gap-1 border-r border-slate-200">
        <FileText size={12} /> Ekstre
      </span>
      {OPTS.map((o) => (
        <button key={o.k} type="button" data-testid={`ekstre-filter-${o.k}`} onClick={() => onChange(o.k)}
          className={`px-2.5 py-2 text-xs font-semibold inline-flex items-center gap-1 transition-colors ${value === o.k ? o.on : "bg-white text-slate-600 hover:bg-slate-50"}`}>
          {o.label}
          <span className={`text-[10px] px-1.5 py-0.5 rounded ${value === o.k ? "bg-white/20" : "bg-slate-100 text-slate-500"}`}>{counts[o.k]}</span>
        </button>
      ))}
    </div>
  );
}
